/**
 * WordPress dependencies
 */
import { Button } from '@safe-wordpress/components';
import { link, linkOff } from '@safe-wordpress/icons';
import { _x } from '@safe-wordpress/i18n';

/**
 * Internal dependencies
 */

export default function LinkedButton( {
	isLinked,
	...props
}: { isLinked?: boolean } & React.ComponentProps<
	typeof Button
> ): JSX.Element {
	const label = isLinked
		? _x( 'Unlink sides', 'command', 'nelio-ab-testing' )
		: _x( 'Link sides', 'command', 'nelio-ab-testing' );

	return (
		<Button
			{ ...props }
			className="component-box-control__linked-button"
			size="small"
			icon={ isLinked ? link : linkOff }
			iconSize={ 24 }
			label={ label }
		/>
	);
}
